// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as ScreenerRouteImport } from './routes/screener'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as PushNotificationsPocRouteImport } from './routes/push-notifications-poc'
import { Route as NotificationsRouteImport } from './routes/notifications'
import { Route as NewsRouteImport } from './routes/news'
import { Route as DashboardRouteImport } from './routes/dashboard'
import { Route as CalendarRouteImport } from './routes/calendar'
import { Route as UserRouteRouteImport } from './routes/user/route'
import { Route as PortfoliosRouteRouteImport } from './routes/portfolios/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as WatchlistsIndexRouteImport } from './routes/watchlists/index'
import { Route as AuthSignupRouteImport } from './routes/auth/signup'
import { Route as AuthSigninRouteImport } from './routes/auth/signin'
import { Route as AuthResetPasswordRouteImport } from './routes/auth/reset-password'
import { Route as AuthForgottenPasswordRouteImport } from './routes/auth/forgotten-password'
import { Route as WatchlistsWatchlistIndexRouteRouteImport } from './routes/watchlists/$watchlistIndex/route'
import { Route as InstrumentTickerRouteRouteImport } from './routes/instrument/$ticker/route'
import { Route as UserSettingsRouteImport } from './routes/user/settings'
import { Route as UserSecurityRouteImport } from './routes/user/security'
import { Route as UserProfileRouteImport } from './routes/user/profile'
import { Route as UserNotificationsRouteImport } from './routes/user/notifications'
import { Route as UserAppearanceRouteImport } from './routes/user/appearance'
import { Route as UserAdvancedRouteImport } from './routes/user/advanced'
import { Route as UserAccountRouteImport } from './routes/user/account'
import { Route as UserAccessibilityRouteImport } from './routes/user/accessibility'
import { Route as PortfoliosIndexRouteImport } from './routes/portfolios/index'
import { Route as PortfoliosNewRouteImport } from './routes/portfolios/new'
import { Route as PortfoliosPortfolioIdRouteRouteImport } from './routes/portfolios/$portfolioId/route'
import { Route as AuthOauthCallbackRouteImport } from './routes/auth/oauth/callback'
import { Route as WatchlistsWatchlistIndexSplatRouteImport } from './routes/watchlists/$watchlistIndex/$'
import { Route as WatchlistsWatchlistIndexOverviewRouteRouteImport } from './routes/watchlists/$watchlistIndex/overview/route'
import { Route as WatchlistsWatchlistIndexNewsRouteRouteImport } from './routes/watchlists/$watchlistIndex/news/route'
import { Route as InstrumentTickerIndexRouteImport } from './routes/instrument/$ticker/index'
import { Route as InstrumentTickerOwnershipRouteImport } from './routes/instrument/$ticker/ownership'
import { Route as InstrumentTickerFinancialsRouteImport } from './routes/instrument/$ticker/financials'
import { Route as PortfoliosPortfolioIdImportRouteImport } from './routes/portfolios/$portfolioId_.import'
import { Route as PortfoliosPortfolioIdTransactionsRouteImport } from './routes/portfolios/$portfolioId.transactions'
import { Route as PortfoliosPortfolioIdTransactionRouteImport } from './routes/portfolios/$portfolioId/transaction'
import { Route as PortfoliosPortfolioIdSettingsRouteImport } from './routes/portfolios/$portfolioId/settings'
import { Route as WatchlistsWatchlistIndexOverviewSettingsRouteImport } from './routes/watchlists/$watchlistIndex/overview/settings'
import { Route as WatchlistsWatchlistIndexNewsSettingsRouteImport } from './routes/watchlists/$watchlistIndex/news/settings'

const ScreenerRoute = ScreenerRouteImport.update({
            id: '/screener',path: '/screener',getParentRoute: () => rootRouteImport
          })
const ResetPasswordRoute = ResetPasswordRouteImport.update({
            id: '/reset-password',path: '/reset-password',getParentRoute: () => rootRouteImport
          })
const PushNotificationsPocRoute = PushNotificationsPocRouteImport.update({
            id: '/push-notifications-poc',path: '/push-notifications-poc',getParentRoute: () => rootRouteImport
          })
const NotificationsRoute = NotificationsRouteImport.update({
            id: '/notifications',path: '/notifications',getParentRoute: () => rootRouteImport
          })
const NewsRoute = NewsRouteImport.update({
            id: '/news',path: '/news',getParentRoute: () => rootRouteImport
          })
const DashboardRoute = DashboardRouteImport.update({
            id: '/dashboard',path: '/dashboard',getParentRoute: () => rootRouteImport
          })
const CalendarRoute = CalendarRouteImport.update({
            id: '/calendar',path: '/calendar',getParentRoute: () => rootRouteImport
          })
const UserRouteRoute = UserRouteRouteImport.update({
            id: '/user',path: '/user',getParentRoute: () => rootRouteImport
          })
const PortfoliosRouteRoute = PortfoliosRouteRouteImport.update({
            id: '/portfolios',path: '/portfolios',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const WatchlistsIndexRoute = WatchlistsIndexRouteImport.update({
            id: '/watchlists/',path: '/watchlists/',getParentRoute: () => rootRouteImport
          })
const AuthSignupRoute = AuthSignupRouteImport.update({
            id: '/auth/signup',path: '/auth/signup',getParentRoute: () => rootRouteImport
          })
const AuthSigninRoute = AuthSigninRouteImport.update({
            id: '/auth/signin',path: '/auth/signin',getParentRoute: () => rootRouteImport
          })
const AuthResetPasswordRoute = AuthResetPasswordRouteImport.update({
            id: '/auth/reset-password',path: '/auth/reset-password',getParentRoute: () => rootRouteImport
          })
const AuthForgottenPasswordRoute = AuthForgottenPasswordRouteImport.update({
            id: '/auth/forgotten-password',path: '/auth/forgotten-password',getParentRoute: () => rootRouteImport
          })
const WatchlistsWatchlistIndexRouteRoute = WatchlistsWatchlistIndexRouteRouteImport.update({
            id: '/watchlists/$watchlistIndex',path: '/watchlists/$watchlistIndex',getParentRoute: () => rootRouteImport
          })
const InstrumentTickerRouteRoute = InstrumentTickerRouteRouteImport.update({
            id: '/instrument/$ticker',path: '/instrument/$ticker',getParentRoute: () => rootRouteImport
          })
const UserSettingsRoute = UserSettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => UserRouteRoute
          })
const UserSecurityRoute = UserSecurityRouteImport.update({
            id: '/security',path: '/security',getParentRoute: () => UserRouteRoute
          })
const UserProfileRoute = UserProfileRouteImport.update({
            id: '/profile',path: '/profile',getParentRoute: () => UserRouteRoute
          })
const UserNotificationsRoute = UserNotificationsRouteImport.update({
            id: '/notifications',path: '/notifications',getParentRoute: () => UserRouteRoute
          })
const UserAppearanceRoute = UserAppearanceRouteImport.update({
            id: '/appearance',path: '/appearance',getParentRoute: () => UserRouteRoute
          })
const UserAdvancedRoute = UserAdvancedRouteImport.update({
            id: '/advanced',path: '/advanced',getParentRoute: () => UserRouteRoute
          })
const UserAccountRoute = UserAccountRouteImport.update({
            id: '/account',path: '/account',getParentRoute: () => UserRouteRoute
          })
const UserAccessibilityRoute = UserAccessibilityRouteImport.update({
            id: '/accessibility',path: '/accessibility',getParentRoute: () => UserRouteRoute
          })
const PortfoliosIndexRoute = PortfoliosIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => PortfoliosRouteRoute
          })
const PortfoliosNewRoute = PortfoliosNewRouteImport.update({
            id: '/new',path: '/new',getParentRoute: () => PortfoliosRouteRoute
          })
const PortfoliosPortfolioIdRouteRoute = PortfoliosPortfolioIdRouteRouteImport.update({
            id: '/$portfolioId',path: '/$portfolioId',getParentRoute: () => PortfoliosRouteRoute
          })
const AuthOauthCallbackRoute = AuthOauthCallbackRouteImport.update({
            id: '/auth/oauth/callback',path: '/auth/oauth/callback',getParentRoute: () => rootRouteImport
          })
const WatchlistsWatchlistIndexSplatRoute = WatchlistsWatchlistIndexSplatRouteImport.update({
            id: '/$',path: '/$',getParentRoute: () => WatchlistsWatchlistIndexRouteRoute
          })
const WatchlistsWatchlistIndexOverviewRouteRoute = WatchlistsWatchlistIndexOverviewRouteRouteImport.update({
            id: '/overview',path: '/overview',getParentRoute: () => WatchlistsWatchlistIndexRouteRoute
          })
const WatchlistsWatchlistIndexNewsRouteRoute = WatchlistsWatchlistIndexNewsRouteRouteImport.update({
            id: '/news',path: '/news',getParentRoute: () => WatchlistsWatchlistIndexRouteRoute
          })
const InstrumentTickerIndexRoute = InstrumentTickerIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => InstrumentTickerRouteRoute
          })
const InstrumentTickerOwnershipRoute = InstrumentTickerOwnershipRouteImport.update({
            id: '/ownership',path: '/ownership',getParentRoute: () => InstrumentTickerRouteRoute
          })
const InstrumentTickerFinancialsRoute = InstrumentTickerFinancialsRouteImport.update({
            id: '/financials',path: '/financials',getParentRoute: () => InstrumentTickerRouteRoute
          })
const PortfoliosPortfolioIdImportRoute = PortfoliosPortfolioIdImportRouteImport.update({
            id: '/$portfolioId_/import',path: '/$portfolioId/import',getParentRoute: () => PortfoliosRouteRoute
          })
const PortfoliosPortfolioIdTransactionsRoute = PortfoliosPortfolioIdTransactionsRouteImport.update({
            id: '/transactions',path: '/transactions',getParentRoute: () => PortfoliosPortfolioIdRouteRoute
          })
const PortfoliosPortfolioIdTransactionRoute = PortfoliosPortfolioIdTransactionRouteImport.update({
            id: '/transaction',path: '/transaction',getParentRoute: () => PortfoliosPortfolioIdRouteRoute
          })
const PortfoliosPortfolioIdSettingsRoute = PortfoliosPortfolioIdSettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => PortfoliosPortfolioIdRouteRoute
          })
const WatchlistsWatchlistIndexOverviewSettingsRoute = WatchlistsWatchlistIndexOverviewSettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => WatchlistsWatchlistIndexOverviewRouteRoute
          })
const WatchlistsWatchlistIndexNewsSettingsRoute = WatchlistsWatchlistIndexNewsSettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => WatchlistsWatchlistIndexNewsRouteRoute
          })





const PortfoliosPortfolioIdRouteRouteChildren = {
  PortfoliosPortfolioIdSettingsRoute: PortfoliosPortfolioIdSettingsRoute,PortfoliosPortfolioIdTransactionRoute: PortfoliosPortfolioIdTransactionRoute,PortfoliosPortfolioIdTransactionsRoute: PortfoliosPortfolioIdTransactionsRoute
}

const PortfoliosPortfolioIdRouteRouteWithChildren = PortfoliosPortfolioIdRouteRoute._addFileChildren(PortfoliosPortfolioIdRouteRouteChildren)



const PortfoliosRouteRouteChildren = {
  PortfoliosPortfolioIdRouteRoute: PortfoliosPortfolioIdRouteRouteWithChildren,PortfoliosNewRoute: PortfoliosNewRoute,PortfoliosIndexRoute: PortfoliosIndexRoute,PortfoliosPortfolioIdImportRoute: PortfoliosPortfolioIdImportRoute
}

const PortfoliosRouteRouteWithChildren = PortfoliosRouteRoute._addFileChildren(PortfoliosRouteRouteChildren)




const UserRouteRouteChildren = {
  UserAccessibilityRoute: UserAccessibilityRoute,UserAccountRoute: UserAccountRoute,UserAdvancedRoute: UserAdvancedRoute,UserAppearanceRoute: UserAppearanceRoute,UserNotificationsRoute: UserNotificationsRoute,UserProfileRoute: UserProfileRoute,UserSecurityRoute: UserSecurityRoute,UserSettingsRoute: UserSettingsRoute
}

const UserRouteRouteWithChildren = UserRouteRoute._addFileChildren(UserRouteRouteChildren)




const InstrumentTickerRouteRouteChildren = {
  InstrumentTickerFinancialsRoute: InstrumentTickerFinancialsRoute,InstrumentTickerOwnershipRoute: InstrumentTickerOwnershipRoute,InstrumentTickerIndexRoute: InstrumentTickerIndexRoute
}

const InstrumentTickerRouteRouteWithChildren = InstrumentTickerRouteRoute._addFileChildren(InstrumentTickerRouteRouteChildren)




const WatchlistsWatchlistIndexNewsRouteRouteChildren = {
  WatchlistsWatchlistIndexNewsSettingsRoute: WatchlistsWatchlistIndexNewsSettingsRoute
}

const WatchlistsWatchlistIndexNewsRouteRouteWithChildren = WatchlistsWatchlistIndexNewsRouteRoute._addFileChildren(WatchlistsWatchlistIndexNewsRouteRouteChildren)




const WatchlistsWatchlistIndexOverviewRouteRouteChildren = {
  WatchlistsWatchlistIndexOverviewSettingsRoute: WatchlistsWatchlistIndexOverviewSettingsRoute
}

const WatchlistsWatchlistIndexOverviewRouteRouteWithChildren = WatchlistsWatchlistIndexOverviewRouteRoute._addFileChildren(WatchlistsWatchlistIndexOverviewRouteRouteChildren)



const WatchlistsWatchlistIndexRouteRouteChildren = {
  WatchlistsWatchlistIndexNewsRouteRoute: WatchlistsWatchlistIndexNewsRouteRouteWithChildren,WatchlistsWatchlistIndexOverviewRouteRoute: WatchlistsWatchlistIndexOverviewRouteRouteWithChildren,WatchlistsWatchlistIndexSplatRoute: WatchlistsWatchlistIndexSplatRoute
}

const WatchlistsWatchlistIndexRouteRouteWithChildren = WatchlistsWatchlistIndexRouteRoute._addFileChildren(WatchlistsWatchlistIndexRouteRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,PortfoliosRouteRoute: PortfoliosRouteRouteWithChildren,UserRouteRoute: UserRouteRouteWithChildren,CalendarRoute: CalendarRoute,DashboardRoute: DashboardRoute,NewsRoute: NewsRoute,NotificationsRoute: NotificationsRoute,PushNotificationsPocRoute: PushNotificationsPocRoute,ResetPasswordRoute: ResetPasswordRoute,ScreenerRoute: ScreenerRoute,InstrumentTickerRouteRoute: InstrumentTickerRouteRouteWithChildren,WatchlistsWatchlistIndexRouteRoute: WatchlistsWatchlistIndexRouteRouteWithChildren,AuthForgottenPasswordRoute: AuthForgottenPasswordRoute,AuthResetPasswordRoute: AuthResetPasswordRoute,AuthSigninRoute: AuthSigninRoute,AuthSignupRoute: AuthSignupRoute,WatchlistsIndexRoute: WatchlistsIndexRoute,AuthOauthCallbackRoute: AuthOauthCallbackRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)